export const PHASES=[
 {id:'onb',name:'On-Boarding',c:'#5fc4cf'},{id:'pre',name:'Pre-Production',c:'#62cf86'},
 {id:'des',name:'Production Design',c:'#ef7fe0'},{id:'shoot',name:'Shoot Details',c:'#f0766b'},
 {id:'pp',name:'Post Prod: Photography',c:'#6f7be6'},{id:'pv',name:'Post Prod: Videography',c:'#a279ea'},
 {id:'pd',name:'Project Packdown',c:'#4db5f3'}];

export const TEMPLATE={
 onb:['Create project in HubSpot','Fill out project brief','Create folders in Google Drive','Send introductory email','Create WhatsApp chat'],
 pre:['Collect references from client','Internal brainstorming meeting','Google Calendar bookings','Vision meeting'],
 des:['Moodboard and look book','Wardrobe and props list'],
 shoot:['Shot list','Run sheet','Crew call sheet'],
 pp:['Select and retouch photos','Deliver photo gallery'],
 pv:['Rough cut','Revision round 1','Final delivery'],
 pd:['Archive footage','Post project report','Send final invoice']};

export const STAGE_DONE={id:'done',name:'Completed',c:'#3fae6a'};

export const STAGES_P=PHASES.concat([STAGE_DONE]);
